// extracted by mini-css-extract-plugin
export var postGrid = "D_bV";
export var wpPageLayout = "D_bT";
export var wpPageRelatedGrid = "D_bW";
export var wpPageRoot = "D_bS";